// removed by extract-text-webpack-plugin
module.exports = {"box":"tzetkcx7mx458zgfctmngbpnq4wdwufwu874wg9k3gcg4d76k62bje7tafzk38tpxpa6y4qp43sv67wxtek49xx1bh5uj55aryjput-styles-module-box"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/Spinner/styles.module.sass
// module id = 561
// module chunks = 0